import { createContext } from 'react'

import { ISEOContext } from '../constants/types/common.types'

const SEOContext = createContext({} as ISEOContext)

export default SEOContext
